export default "__VITE_ASSET__DO3zDr42__"